import React from 'react';
import { AccommodationBookingStatus } from '../../../../types/accommodation';

const CONFIG: Record<
  AccommodationBookingStatus,
  { label: string; classes: string }
> = {
  pending: {
    label: 'Pending',
    classes: 'bg-yellow-50 text-yellow-700',
  },
  confirmed: {
    label: 'Confirmed',
    classes: 'bg-blue-50 text-blue-700',
  },
  checked_in: {
    label: 'Checked in',
    classes: 'bg-green-50 text-green-700',
  },
  checked_out: {
    label: 'Checked out',
    classes: 'bg-gray-100 text-gray-600',
  },
  cancelled: {
    label: 'Cancelled',
    classes: 'bg-red-50 text-red-600',
  },
  no_show: {
    label: 'No show',
    classes: 'bg-orange-50 text-orange-600',
  },
};

/** Solid background colours for booking spans on the timeline calendar */
export const STATUS_TIMELINE_CLASSES: Record<
  AccommodationBookingStatus,
  string
> = {
  pending: 'bg-yellow-400 text-white',
  confirmed: 'bg-emerald-500 text-white',
  checked_in: 'bg-blue-500 text-white',
  checked_out: 'bg-gray-400 text-white',
  cancelled: 'bg-red-400 text-white',
  no_show: 'bg-orange-400 text-white',
};

interface Props {
  status: AccommodationBookingStatus;
}

export const BookingStatusBadge: React.FC<Props> = ({ status }) => {
  const { label, classes } = CONFIG[status] ?? {
    label: status,
    classes: 'bg-gray-100 text-gray-600',
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${classes}`}
    >
      {label}
    </span>
  );
};
